export default {
  pages: {
    applicationsList: {
      title: 'Arizalar',
      createQrApplication: 'QR orqali ariza berish',
    },
  },
};
